import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const GA_MEASUREMENT_ID = 'G-XC31SW9JKM';

//
// The gtag snippet in public/index.html sends the page_view for the initial
// load. Switching language is a client-side navigation (/es -> /en) that gtag
// never sees, so those are reported here -- skipping the first render to avoid
// double counting the landing page.
//
export default function Analytics() {
  const location = useLocation();
  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}
